<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Panel Front Sipariş Takip</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"><a>Anasayfa</a></router-link>
              <li class="breadcrumb-item active">Panel Front Sipariş Takip</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Panel Front Sipariş Takip

              </div>
              <div class="card-body">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <div class="row">
                    <div class="col-xl-2 my-1">
                      <input type="text" placeholder="Müşteri ID" class="form-control form-control-sm"
                        v-model="search.code" />
                    </div>

                    <div class="col-xl-2 my-1">
                      <select class="form-control form-control-sm" placeholder="Item" v-model="search.shopTrackItemId">
                        <option value="-1" selected>Item Seçiniz</option>
                        <option v-for="(data, index) in itemList" :key="index" v-bind:value="data.id">
                          {{ data.itemName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xl-2 my-1">
                      <select class="form-control form-control-sm" v-model="search.shopTrackStatusId">
                        <option value="-1" selected>Status Seçiniz</option>
                        <option v-for="(data, index) in statusList" :key="index" v-bind:value="data.id">
                          {{ data.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xl-2 my-1">
                      <select class="form-control form-control-sm" v-model="search.shopTrackCategoryId">
                        <option value="-1" selected>Category Seçiniz</option>
                        <option v-for="(data, index) in categoryList" :key="index" v-bind:value="data.id">
                          {{ data.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xl-2 my-1">
                      <button class="btn btn-info btn-sm w-100" @click="pagination">
                        <i class="fas fa-search"></i> Filtrele
                      </button>

                    </div>
                    <div class="col-xl-2 my-1">
                      <button class="btn btn-danger btn-sm w-100" @click="reset">
                        Temizle
                      </button>
                    </div>
                  </div>
                  <br />
                  <div class="table-responsive">
                    <table class="table table-striped projects">
                      <thead>
                        <tr>
                          <th>#</th>

                          <th>Sipariş ID</th>
                          <th>Kategori </th>
                          <th>Ürün </th>
                          <th>Durum </th>
                          <th>Müşteri Kodu</th>
                          <th>Kullanıcı Adı </th>
                          <th>Sipariş Tarihi </th>
                          <th>Toplam </th>
                          <th>Puan</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data, index) in datas" :key="index">
                          <td>{{ ++index + (page - 1) * count }}</td>
                          <td>
                            {{ data.track_id }}

                          </td>
                          <td>{{ data.shopTrackCategory }}</td>
                          <td>{{ data.shopTrackItem }}</td>
                          <td> {{ data.shopTrackStatus }}</td>
                          <td>{{ data.customerCode }}</td>
                          <td> {{ data.userName }}</td>
                          <td> {{ data.orderDate | DateFormat }}</td>
                          <td> {{ data.total }}</td>
                          <td>{{ data.point }}</td>
                        </tr>
                        <tr>
                          <td v-if="datas.length == 0" colspan="6" class="text-center">
                            Kayıt Bulunamadı
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <pagination v-model="page" :records="rows" :per-page="count" @paginate="pagination" />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>

    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>
<script>

export default {
  data() {
    return {
      page: 1,
      count: 10,
      rows: 0,
      datas: [],
      auth: this.$store.getters.getModules,
      data: {
        id: 0,
        code: "",
        type: [],
        description: "",
      },
      overlay: false,
      search: {
        code: "",
        shopTrackItemId: 0,
        shopTrackStatusId: 0,
        shopTrackCategoryId: 0
      },
      statusList: [],
      categoryList: [],
      itemList: []
    };
  },

  methods: {
    pagination(value) {
      this.getDatas();
      this.getDatas(true);
    },
    reset() {
      this.page = 1;
      this.search = {
        code: "",
        bonus: "",
      };
      this.getDatas();
      this.getDatas(true);
    },
    getDatas(type = false) {
      if (!type) this.overlay = true;
      this.$http
        .post("PanelFront/GetOrderTrackingReport", {
          shopTrackItemId: this.search.shopTrackItemId,
          shopTrackStatusId: this.search.shopTrackStatusId,
          shopTrackCategoryId: this.search.shopTrackCategoryId,
          customerCode: this.search.code,
          getOnlyCount: type,
          page: this.page - 1,
        })
        .then((response) => {
          if (type) this.rows = response.data;
          else {
            this.datas = response.data;
            this.overlay = false;
          }
        });
    },
    getFilterOptions() {
      this.$http
        .get("PanelFront/GetOrderTrackingReportFilterOptions")
        .then((response) => {
          let data = response.data;
          this.statusList = data.statusList;
          this.itemList = data.items;
          this.categoryList = data.categories;
        });
    },
    resetModal() {
      this.data = {
        id: 0,
        code: "",
        type: [],
        description: "",
      };
      this.$v.$reset();
      $("#modal").modal();
    },

  },
  filters: {
    DateFormat(value) {
      if (!value) return "İşlem Sırasında";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  created() {
    this.getDatas();
    this.getDatas(true);
    this.getFilterOptions();
  },
  watch: {
    "$store.getters.getSite"() {
      this.getDatas();
      this.getDatas(true);
    },
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/OrderTrackingReport/PanelFrontOrderTrackingReport.vue